import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastMsgComponent } from '../components/toast-msg/toast-msg.component';

export type ToastType = 'success' | 'warning' | 'danger' | 'info';
export type ToastPosition = 'left' | 'right';
export interface ToastConfig {
	message: string;
	type: ToastType;
	position: ToastPosition;
}

// Ported from customer-website's ToastService (MatSnackBar-backed card design)
// so both apps' toasts look and behave the same.
@Injectable({
	providedIn: 'root'
})
export class ToastService {
	private _snackBar = inject(MatSnackBar);

	// Shared state for components that reactively watch the active toast.
	readonly currentToast: WritableSignal<ToastConfig | null> = signal<ToastConfig | null>(null);

	displayToast(message: string, position: ToastPosition | null = 'right', type: ToastType = 'info', longDuration = false): void {
		const duration = longDuration ? 10000 : 5000;
		const horizontalPosition = position === 'left' ? 'left' : 'right';

		const toastConfig: ToastConfig = {
			message,
			type,
			position: horizontalPosition
		};
		this.currentToast.set(toastConfig);

		const snackBarRef = this._snackBar.openFromComponent(ToastMsgComponent, {
			duration,
			horizontalPosition,
			verticalPosition: 'top',
			data: toastConfig,
			announcementMessage: message,
			politeness: type === 'danger' ? 'assertive' : 'polite',
			panelClass: [
				`toast-panel-${type}`
			]
		});

		snackBarRef.afterDismissed().subscribe(() => {
			if (this.currentToast() === toastConfig) this.currentToast.set(null);
		});
	}
}
